import { TableContainer } from '@mui/material';
import { styled } from '@mui/material/styles';

import { Box } from '../../atoms/Box';

import { COLORS } from '../../../configs/colors';

export const RoleBox = styled(Box)`
  width: 100%;
  height: 100%;
  border: 1px solid ${COLORS.CardBorder};
  border-radius: 5px;
  background-color: ${COLORS.CardBackground};
  box-sizing: border-box;
  margin-bottom: 10px;
  padding: 10px;
`;

export const StyledTableContainer = styled(TableContainer)`
  border: 1px solid ${COLORS.CardBorder};
  border-radius: 5px;
  overflow: auto;
  width: 100%;
  height: 45%;
`;

export const ServiceImage = styled('img')`
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
`;